<template>
  <div>
    <h3 class="pt-4">
      Kalendarz
      <font-awesome-icon
        v-b-popover.hover="'Kliknij i przeciągnij na kalendarzu aby wybrać dni wolne'"
        title="Pomoc"
        style
        class="float-right helper"
        icon="question"
      ></font-awesome-icon>
    </h3>
    <hr>
    <loader :show="showLoader"></loader>
    <full-calendar
      ref="calendar"
      :events="calendarEvents"
      :config="calendarConfig"
      @event-created="openNewEventModal"
      @event-selected="openEventModal"
      @view-render="updateQueryParams"
      @event-render="updateEventTitle"
    ></full-calendar>

    <daysoff-add
      v-if="showEditModal"
      :show="showEditModal"
      :event="selectedEvent"
      :dates="dayOffForm"
      @submit="saveDayOff"
      @cancel="hideEditModal"
    ></daysoff-add>

    <daysoff-event
      v-if="showEventModal"
      :show="showEventModal"
      :event="selectedEvent"
      :isAccepted="!!selectedEvent.accepted"
      @edit="openEditModal"
      @cancel="hideEventModal"
      @deny="deleteDayOff"
      @accept="acceptDayOff"
      @absence="acceptAbsenceType"
    ></daysoff-event>
  </div>
</template>

<script>
import 'fullcalendar/dist/fullcalendar.css';
import 'fullcalendar/dist/locale/pl';
import moment from 'moment';
import { FullCalendar } from 'vue-full-calendar';

import DaysoffAdd from './Add.vue';
import DaysoffEvent from './Event.vue';
import Loader from '@/components/Loader.vue';
import { DayOffResource } from '@/resources/dayOff.resource';
import CalendarService from '@/services/calendar.service';
import authenticationService from '@/services/authentication.service';
import calendarService from '@/services/calendar.service';
import { dayOffService } from '@/services/dayOff.service';

export default {
  components: {
    FullCalendar,
    DaysoffAdd,
    DaysoffEvent,
    Loader
  },
  data() {
    return {
      calendarConfig: {
        defaultView: 'month',
        editable: false,
        locale: 'pl',
        selectable: true,
        header: {
          left: 'title',
          center: '',
          right: 'prev,next'
        },
        height: 'auto'
      },
      dayOffForm: {},
      dbEvents: [],
      showEditModal: false,
      showEventModal: false,
      showLoader: true,
      selectedEvent: null
    };
  },
  beforeMount() {
    const { year, month } = this.$route.query;
    if (!isNaN(year) && !isNaN(month)) {
      this.calendarConfig.defaultDate = moment({ y: year, month: month - 1, d: 1 }).toDate();
      this.refreshEvents(year, month);
    }
  },
  methods: {
    async refreshEvents(year, month) {
      const data = await DayOffResource.list({ year: parseInt(year, 10), month: parseInt(month, 10) });
      this.showLoader = false;
      this.dbEvents = [...data.dayoffs, ...data.holidays];
    },
    updateQueryParams(view) {
      this.$router.push({
        query: {
          year: view.intervalStart.year(),
          month: view.intervalStart.month() + 1
        }
      });
    },
    openNewEventModal(event) {
      this.dayOffForm.dateStart = event.start.toDate();
      this.dayOffForm.dateEnd = event.end.add(-1, 'd').toDate();
      this.showEditModal = true;
    },
    openEventModal(event) {
      if (authenticationService.isLoggedUser(event.userID) || authenticationService.is('manager', 'hr')) {
        this.selectedEvent = this.dbEvents.find(e => e.id === event.dayOffId);
        this.showEventModal = true;
      }
    },
    hideEventModal() {
      this.showEventModal = false;
      this.selectedEvent = null;
    },
    openEditModal() {
      this.showEditModal = true;
    },
    hideEditModal() {
      this.showEditModal = false;
      this.selectedEvent = null;
    },
    async deleteDayOff(event) {
      try {
        await DayOffResource.deleteDayOff(event.id);
        const eventIndex = this.dbEvents.findIndex(e => e.id === event.id);
        this.dbEvents = this.dbEvents.filter((e, index) => index !== eventIndex);
        this.hideEventModal();
      } catch (error) {
        console.warn(error);
        this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas odrzucania dnia wolnego' });
      }
    },
    async acceptDayOff(event) {
      try {
        if (authenticationService.is('admin', 'hr', 'manager')) {
          const data = await DayOffResource.accept(event.id);
          if (data.accepted === true) {
            this.$set(this.dbEvents.find(e => e.id === event.id), 'accepted', true);
          }
          this.hideEventModal();
        }
      } catch (error) {
        console.warn(error);
        this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas akceptacji dnia wolnego' });
      }
    },
    async saveDayOff(form, userId, absenceId, id) {
      dayOffService.save(form, userId, absenceId, id).then(dbEvent => {
        if (id) {
          const dbEventIndex = this.dbEvents.findIndex(event => event.id === id);
          this.$set(this.dbEvents, dbEventIndex, dbEvent);
          return;
        }
        this.dbEvents.push(dbEvent);
      });
    },
    updateEventTitle(event, element, view) {
      if (event.rendering === 'background') {
        element.append(event.title);
      } else {
        calendarService.showDayOffPopup(event, element, this.$root);
      }
      calendarService.prependDayOffIcons(event, element);
    },
    async acceptAbsenceType(event, absenceId) {
      if (this.$is('admin', 'hr')) {
        const acceptResult = await DayOffResource.acceptAbsence(event.id, absenceId);
        const dbEvent = this.dbEvents.find(e => e.id === event.id);
        this.$set(dbEvent, 'accepted', acceptResult.accepted);
        this.$set(dbEvent, 'hrAccept', true);
        this.showEventModal = false;
      }
    }
  },
  computed: {
    calendarEvents() {
      return this.dbEvents.map(event => CalendarService.dayOffToCalendarEvent(event));
    }
  },
  watch: {
    $route(to, from) {
      this.refreshEvents(to.query.year, to.query.month);
    }
  }
};
</script>
<style>
.fc-bgevent {
  opacity: 1;
  background-color: rgba(255, 150, 150, 1);
  color: rgba(70, 70, 70, 0.8);
}
.helper {
  cursor: pointer !important;
  color: #666 !important;
  border: 4px solid #666 !important;
  border-radius: 100% !important;
  width: 35px !important;
  height: 35px !important;
  padding: 3px !important;
}
</style>
